import { useRouterState } from '@tanstack/react-router'

/**
 * The pathname of the route that is actually on screen, for persistent chrome
 * (desktop rail, mobile tab bar) that derives an active-item highlight.
 *
 * `useRouterState().location` flips as soon as a navigation starts, which is
 * before the router commits the new matches inside `document.startViewTransition`.
 * Chrome that reads it re-renders BEFORE the view-transition "old" snapshot is
 * captured, so the highlight change lands in both snapshots and pops instead of
 * cross-fading (see the `data-app-chrome` block in src/theme/variables.css).
 * The leaf match's pathname is committed inside the transition callback (the
 * same store update that swaps the page), so the highlight change belongs to
 * the "new" snapshot only. Falls back to `location` before any match commits.
 */
export function useCommittedPathname(): string {
  return useRouterState({
    select: (s) => s.matches[s.matches.length - 1]?.pathname ?? s.location.pathname,
  })
}
